"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var components_1 = require("@lsg/components");

var Paragraph_1 = require("@lsg/components/lib/components/atoms/Paragraph/Paragraph");

var react_components_1 = require("@lws/react-components");

var util_1 = require("@lws/react-components/dist/components/RichTextRenderer/renderers/util");

exports.SpanElement = function (_a) {
  var children = _a.children;
  return react_1["default"].createElement("span", null, children);
};

exports.StageHeadline = function (_a) {
  var overline = _a.overline,
      headline = _a.headline;
  return react_1["default"].createElement("div", null, overline && react_1["default"].createElement(components_1.Paragraph, {
    size: Paragraph_1.Sizes.LEAD
  }, overline), headline && react_1["default"].createElement("span", null, react_1["default"].createElement(react_components_1.ContentfulRichTextRenderer, {
    content: headline,
    options: util_1.footnotesFragmentsOptions
  })));
};